import { render, staticRenderFns } from "./ProductReceptsV3.vue?vue&type=template&id=153ac5f7&scoped=true&"
import script from "./ProductReceptsV3.vue?vue&type=script&lang=js&"
export * from "./ProductReceptsV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductReceptsV3.vue?vue&type=style&index=0&id=153ac5f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ac5f7",
  null
  
)

export default component.exports